import { Box, useMediaQuery, useTheme } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import DesktopLayout from "./DesktopLayout";
import HeaderLayout from "./HeaderLayout";

const ResponsiveLayout = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const location = useLocation();

  // Pages that should not show header
  const noHeaderPages = ["/connect-stripe-account"];
  // const noHeaderPages = ["/review-booking", "/connect-stripe-account"];

  // Check if current page should hide header
  const shouldHideHeader = noHeaderPages.some((path) =>
    location.pathname.includes(path),
  );

  // If header should be hidden, render just the outlet
  if (shouldHideHeader) {
    return (
      <Box sx={{ minHeight: "100vh" }}>
        <Outlet />
      </Box>
    );
  }

  // Use desktop layout for desktop screens, mobile layout for mobile screens
  if (isDesktop) {
    return <DesktopLayout />;
  }

  return <HeaderLayout />;
};

export default ResponsiveLayout;
